import { renderBreadcrumbDivider_unstable } from '@fluentui/react-breadcrumb';

/**
 * Renders the final JSX of the BreadcrumbDivider component, given the state.
 */
export const renderBreadcrumbDivider = renderBreadcrumbDivider_unstable;
